var $a3c26eddfd29ef07$exports = {};
$a3c26eddfd29ef07$exports = {
    "more": `Weitere Elemente`
};


export {$a3c26eddfd29ef07$exports as default};
//# sourceMappingURL=de-DE.mjs.map
